<script>
import CardListCollapsible from '@/components/CardListCollapsible'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import SideMenu from '@/components/SideMenu/SideMenu'
import SideMenuItem from '@/components/SideMenu/SideMenuItem'
import SideMenuSeparator from '@/components/SideMenu/SideMenuSeparator'
import ResponsiveMenu from '@/components/ResponsiveMenu/ResponsiveMenu'
import ResponsiveMenuItem from '@/components/ResponsiveMenu/ResponsiveMenuItem'
import BackgroundIllustration from '@/components/BackgroundIllustration'
import Button from '@/components/Button'
import CardListEditTags from '@/views/CardListEditTags'
import DOMUtils from '@/utils/DOMUtils'
import EventsUtils from '@/utils/eventsUtils'
import Mark from 'mark.js'
import Fuse from 'fuse.js'
import UrlJoin from 'url-join'
import DateUtils from '@/utils/dateUtils'
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'card-list',

    props:
    {
        cards: { type: Array, required: true },
        tags: { type: Array, required: true },
        cardObjectName: { type: String, required: true },
        tagsValidator: { type: Function },
        cardContentCreator: { type: Function },
    },

    created ()
    {
    },

    render ()
    {
        const isDesktop = DOMUtils.reactives.currentMediaName == 'desktop'

        return (
            <div id='card-list-view'>
                <side-menu v-show={!isDesktop} ref='mobileMenu' title='Libellés' on-item-selected={this.onMenuItemSelected}>
                    { this.tags.map(tag => <side-menu-item icon={require(`@/assets/img/${tag.icon.name}.svg`)} name={tag.name} id={tag.id} path={'/tags/' + tag.id} />) }
                    <side-menu-separator />
                    <side-menu-item icon={require('@/assets/img/gear.svg')} name='Éditer les libellés' id='edit-tags' path='edit-tags' />
                </side-menu>

                <responsive-menu v-show={isDesktop} ref='desktopMenu' orientation='vertical' on-item-selected={this.onMenuItemSelected}>
                    { this.tags.map(tag => <responsive-menu-item icon={require(`@/assets/img/${tag.icon.name}.svg`)} name={tag.name} id={tag.id} path={'/tags/' + tag.id} />) }
                    <side-menu-separator />
                    <responsive-menu-item icon={require('@/assets/img/gear.svg')} name='Éditer les libellés' id='edit-tags' path='edit-tags' />
                </responsive-menu>

                <div id='content'>
                    <div id='header'>
                        <inline-svg v-show={!isDesktop} id='side-menu-icon' src={require('@/assets/img/menu.svg')} on-click={() => this.$refs.mobileMenu.showMenu()} />
                        <floating-label-text-input id='card-search-field' class='light-gray-style' placeholder={`Rechercher un ${this.cardObjectName}`}
                            icon={require('@/assets/img/magnifying-glass-thin.svg')} placeholder-disappear-on-text={true} v-model={this.searchFieldValue} />
                    </div>

                    <Button v-show={this.hasFilters} text='Supprimer les filtres' type='light' icon={require('@/assets/img/cross.svg')} id='remove-filters-btn'
                        on-click={this.removeFilters} />

                    <div v-show={(this.$route.params.pathMatch||'').startsWith('tags/')} class='card-list'>
                        
                        <div v-show={!isDesktop} id='label-title'>
                            {this.cardObjectName}s {(this.tags.find(t => t.id == this.filter.tag)||{name:''}).name.toLowerCase()}
                        </div>

                        {
                            this.cards.map((c, i) =>
                                <div>
                                    {
                                        !DateUtils.areSameDay(c.date, (this.cards[i-1] ||{}).date) && this.filteredCardsIds.some(id => DateUtils.areSameDay(this.cards.find(c => c.id  == id).date, c.date))
                                            && c.date &&
                                        <div class='report-date'>
                                            { new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date(c.date)) }
                                        </div>
                                    }
                                    
                                    <div v-show={this.filteredCardsIds.includes(c.id)}>
                                        <card-list-collapsible title={c.title} description={c.description} tags-definitions={this.tags} expanded={!!this.filter.search}
                                            card-data={c} tags-validator={this.tagsValidator} on-tags-set={tags => this.onCardTagsSet(c, tags)} ref={'card-' + c.id + '-collapsible'}>
                                                { this.cardContentCreator(c) }
                                        </card-list-collapsible>
                                    </div>
                                </div>
                            )
                        }

                        <div v-show={this.filteredCardsIds.length == 0 && this.filter.search}>
                            <background-illustration image={require('@/assets/img/document-search.svg')}>
                                <div>Aucun {this.cardObjectName} ne correspond à votre recherche.</div>
                                <Button v-show={this.filter.tag} text='Rechercher dans tous les libellés' on-click={() => this.filter.tag = ''} />
                            </background-illustration>
                        </div>
                        <div v-show={this.filteredCardsIds.length == 0 && !this.filter.search}>
                            <background-illustration image={require('@/assets/img/empty-box.svg')}>
                                Aucun {this.cardObjectName} n'est libellé comme <b>{(this.tags.find(t => t.id == this.filter.tag)||{}).name}</b>.
                                Assignez des libellés en cliquant sur <inline-svg class='icon' src={require('@/assets/img/tag.svg')}/>.
                            </background-illustration>
                        </div>
                    </div>
                    
                    <card-list-edit-tags v-show={this.itemPath == 'edit-tags'} cards={this.cards} tags={this.tags} card-object-name={this.cardObjectName}
                        on-tags-modified={tags => this.$emit('tags-modified', tags)} on-cards-tags-changed={cards => this.$emit('cards-tags-changed', cards)} />
                </div>

                <router-view />
            </div>
        )
    },

    data () 
    {
        return {
            searchFieldValue: '',
            filter: { tag: '', search: '', ids: [] },
            itemPath: '/',
            mark: null,
            fuse: null
        }
    },

    mounted ()
    {
        this.mark = new Mark('.card-list-collapsible .description, .card-list-collapsible .title, .markable')
        const keys = ['title', 'description', 'shortDate', 'longDate', 'senderMail', 'senderFirstName', 'senderLastName',
            'sender.mail', 'sender.firstName', 'sender.lastName', 'sender.phone']
        this.fuse = new Fuse([], { threshold: 0.3, keys })

        document.addEventListener('router-after-each', this.routerAfterEach)
        const targettedCardId = this.$route.query.id

        if (targettedCardId)
        {
            var findCardAttemptCount = 0

            const findCardInterval = setInterval(async () =>
            {
                findCardAttemptCount += 1
                console.log('Trying to find card', targettedCardId, 'attempt', findCardAttemptCount)
                if (findCardAttemptCount > 10) return clearInterval(findCardInterval)

                const card = this.cards.find(c => c.id == targettedCardId)
                if (!card) return console.warn(this.$route.path, 'card', targettedCardId, 'not found')

                console.log('Card found', card)
                const cardLocation = UrlJoin(this.baseRoute.path, 'tags', card.tags[0])
                console.log('Going to card location', cardLocation)
                await this.$router.replace(cardLocation)
                const collapsible = this.$refs['card-' + card.id + '-collapsible']
                collapsible.isExpanded = true
                DOMUtils.scrollToElement(collapsible.$el, 100)
                DOMUtils.animateCSS(collapsible.$el, 'pulse', '0.5s')
                clearInterval(findCardInterval)
            }, 1000)
        }
    },

    computed:
    {
        filteredCardsIds ()
        {
            var cards = this.cards

            if (this.filter.tag)
            {
                cards = cards.filter(r => r.tags.includes(this.filter.tag))
            }

            if (this.filter.search)
            {
                const getShortDate = (r) => new Intl.DateTimeFormat('fr-FR', { month: 'numeric', year: 'numeric', day: 'numeric' }).format(new Date(r.date))
                const getLongDate = (r) => new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(r.date))

                const elements = cards.map((r, index) => ({ ...r, title: r.reason, index, shortDate: getShortDate(r), longDate: getLongDate(r) }))
                this.fuse.setCollection(elements)
                const fuseResultIndexes = this.fuse.search(this.filter.search).map(r => r.index)
                const matchedElements = cards.filter((r, index) => fuseResultIndexes.includes(index))
                cards = matchedElements
            }

            if (Array.isArray(this.filter.ids) && this.filter.ids.length >= 1)
            {
                cards = cards.filter(r => this.filter.ids.includes(r.id))
            }

            return cards.map(r => r.id)
        },

        hasFilters ()
        {
            return !StringUtils.isEmptyString(this.filter.search) || (this.filter.ids || []).length > 0
        },

        baseRoute ()
        {
            return this.$route.matched.find(e => e.instances.default && e.instances.default.$children.includes(this))
        }
    },

    watch:
    {
        searchFieldValue: EventsUtils.debounce(function (after, before)
        {
            this.filter.search = after
        }, 50),

        'filter.search':
        {
            handler: function (after, before)
            {
                this.mark.unmark(before)
                this.mark.mark(after || '', {separateWordSearch: true})
            },
            deep: true
        },

        'filter.tag':
        {
            handler: function (after, before)
            {
                if (after && after != '*') return

                this.itemPath = '/'
                this.$refs.mobileMenu.selectMenuItem(null)
                this.$refs.desktopMenu.selectMenuItem(null)
            },
            deep: true
        }
    },

    beforeDestroy ()
    {
        document.removeEventListener('router-after-each', this.routerAfterEach)
    },

    methods:
    {
        routerAfterEach (e)
        {
            this.extractTagFromCurrentPath()
            this.searchFieldValue = ''
            this.selectMenuItemFromCurrentPath()
        },

        extractTagFromCurrentPath ()
        {          
            const pathSplitted = this.$route.path.split('/')
            if (pathSplitted.includes('tags'))
            {
                const tag = pathSplitted[pathSplitted.indexOf('tags') + 1]
                console.log('Extracting tag', tag, 'from path', this.$route.path)
                this.filter.tag = tag
            }
        },

        onMenuItemSelected (item)
        {
            if (item && item.path)
            {
                this.removeFilters()
                this.extractTagFromCurrentPath()
                this.itemPath = item.path
                this.$router.push({ path: UrlJoin(this.baseRoute.path, item.path), append: true })
            }
        },

        selectFirstMenuItem ()
        {
            this.$refs.mobileMenu.selectFirstMenuItem()
            this.$refs.desktopMenu.selectFirstMenuItem()
        },

        selectMenuItemFromCurrentPath ()
        {
            if (!this.baseRoute) return
            if (this.$route.path == this.baseRoute.path) return this.selectFirstMenuItem()

            const itemPath = this.$route.path.replace(this.baseRoute.path, '')
            console.log('Selecting menu item associated to path', itemPath, 'from', this.$route.fullPath)
            const mobileItem = this.$refs.mobileMenu.getMenuItemByPath(itemPath)
            const desktopItem = this.$refs.desktopMenu.getMenuItemByPath(itemPath)
            if (!mobileItem || !desktopItem) return console.warn('Could not find item associated with path', itemPath)
            this.$refs.mobileMenu.selectMenuItem(mobileItem)
            this.$refs.desktopMenu.selectMenuItem(desktopItem)
        },

        /**
         * @param {object} card
         * @param {Array<string>} tags
         */
        onCardTagsSet (card, tags)
        {
            card.tags = tags
            this.$emit('cards-tags-changed', [card])
        },

        removeFilters ()
        {
            this.filter.search = ''
            this.filter.ids = []
        }
    },

    components:
    {
        CardListCollapsible,
        FloatingLabelTextInput,
        SideMenu,
        SideMenuItem,
        ResponsiveMenu,
        SideMenuSeparator,
        ResponsiveMenuItem,
        BackgroundIllustration,
        Button,
        CardListEditTags
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#card-list-view
{
    padding-bottom: calc(var(--theme-horizontal-menu-height) + 1vh);
    
    .OnDesktop({
        padding-bottom: 5vh;
    });

    .responsive-menu.vertical
    {
        width: 260px;
        margin-right: 20px;
        max-height: 77vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    > #content
    {
        margin-left: 3%;
        margin-right: 3%;

        .OnDesktop({
            border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
            margin-right: calc(260px + 10px + 3%);
        });

        #header
        {
            margin-top: calc(var(--theme-status-bar-height) + 12px);
            display: flex;
            flex-direction: row;
            align-items: center;

            #side-menu-icon
            {
                .WidthHeight(30px);
                fill: var(--theme-background-text-color-heavy);
                margin-right: 20px;
                cursor: pointer;
            }

            #card-search-field
            {
                width: 100%;
            }
        }
        
        #remove-filters-btn
        {
            margin-top: 10px;
            padding: 5px 10px;
        }

        .card-list
        {
            display: flex;
            flex-direction: column;
            margin-top: 3vh;

            #label-title
            {
                .CapitalizeFirstLetter();
                font-weight: 600;
                margin-bottom: 5px;
            }

            .report-date
            {
                color: var(--theme-background-text-color-heavy);
                margin-bottom: 10px;
                font-size: 13px;

                .CapitalizeFirstLetter();
            }

            .all-done
            {
                .background-illustration
                {
                    .image
                    {
                        fill: var(--theme-background-text-color-soft);
                        filter: none;
                    }
                }
            }

            .background-illustration
            {
                .image
                {
                    opacity: 0.8;
                }

                .button
                {
                    margin: auto;
                    margin-top: 20px;
                    font-size: 13px;
                }

                .icon
                {
                    .WidthHeight(17px);
                    fill: var(--theme-background-text-color-heavy);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CardList.vue